import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import {
	CollapseComponent,
	DividerComponent,
	EmptyStateComponent,
	IconComponent,
	InfoGroupComponent,
	TagComponent,
	TileComponent,
} from '@tecalisdev/infinity';
import { SafeDatePipe } from '../../../../core/pipes/safe-date.pipe';
import { OPERATION_STATUS } from '../../../../operations/models/operations.models';
import {
	resolveTfaChannel,
	resolveTfaChannelLabelKey,
} from '../../../../operations/utils/tfa-display.util';
import { PhoneDisplayComponent } from '../../../../shared/components/phone-display/phone-display.component';
import { MasterService } from '../../../../shared/services/master.service';
import { DeveloperCurlButtonComponent } from '../../../../shared/components/developer-curl-button/developer-curl-button.component';
import { notAvailableLabel } from '../../../../core/utils/utils';
import { IOperationTfaDetail } from '../../../models/processes.models';

@Component({
	selector: 'app-operation-detail-tfa',
	imports: [
		TranslatePipe,
		SafeDatePipe,
		CollapseComponent,
		TileComponent,
		EmptyStateComponent,
		InfoGroupComponent,
		IconComponent,
		TagComponent,
		DividerComponent,
		PhoneDisplayComponent,
		DeveloperCurlButtonComponent,
	],
	templateUrl: './operation-detail-tfa.component.html',
})
export class OperationDetailTfaComponent {
	@Input() operation?: IOperationTfaDetail;
	@Input() processUuid?: string;
	@Input() expanded = false;
	@Output() toggleCollapse = new EventEmitter<boolean>();

	public readonly masterService = inject(MasterService);
	private readonly trans = inject(TranslateService);
	public readonly OPERATION_STATUS = OPERATION_STATUS;

	public get operationCurlPath(): string {
		return this.processUuid && this.operation?.uuid
			? `/process/${this.processUuid}/operations/${this.operation.uuid}`
			: '';
	}

	public tfaStatusKey(state: string | undefined): string {
		if (!state) {
			return OPERATION_STATUS.INIT;
		}
		return state;
	}

	public tfaChannelLabel(tfa: IOperationTfaDetail): string {
		const channel = resolveTfaChannel(tfa);
		const key = resolveTfaChannelLabelKey(channel);
		if (key) {
			return this.trans.instant(key);
		}
		return channel || notAvailableLabel(this.trans);
	}

	public formatSecondsToMinutes(seconds: number): string {
		if (seconds === null || seconds === undefined) {
			return '';
		}
		const total = Math.max(0, Math.trunc(Number(seconds) || 0));
		const minutes = Math.floor(total / 60);
		const remainingSeconds = total % 60;
		return `${minutes}m ${remainingSeconds}s`;
	}
}
